module.exports = __webpack_public_path__ + "img/岳晓东.57f223b2.png";